<template>
  <pack>
    <zt-title class="mb24">支付宝发放结果</zt-title>

     <!-- 查询表单 -->
    <el-form class="finder">
      <el-date-picker
        type="daterange"
        v-model="date"
        v-bind="datePickerBind"
        start-placeholder="申请时间"
        end-placeholder="申请时间"
        @change="onDatePickerChange"
        class="mr16 mb8"
      />
      <el-form-item label="支付状态" class="mr16 mb8">
        <el-select v-model="form.status" placeholder="请选择状态" clearable>
          <el-option label="申请中" :value="0"></el-option>
          <el-option label="成功" :value="1"></el-option>
          <el-option label="失败" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <zt-button
        type="primary"
        class="mr16 mb8"
        :loading="formLoading"
        @click.enter.exact="onSubmit"
        native-type="submit"
        width="80px"
        >搜索</zt-button
      >
      <zt-button
        class="mr16 mb8"
        :loading="formLoading"
        @click="onReset"
        width="80px"
      >清空</zt-button>
    </el-form>

    <!-- 表 -->
    <el-table :data="list" size="medium" class="mt12">
      <el-table-column label="编号" prop="id" min-width="50px" />
      <el-table-column label="申请时间" prop="apply_time">
      </el-table-column>
      <el-table-column label="订单号" prop="out_biz_no" min-width="150px">
      </el-table-column>
      <el-table-column label="支付宝业务单号" prop="batch_trans_id"  min-width="110px">
        <span slot-scope="{ row }">{{ row.batch_trans_id ===null ? "--":row.batch_trans_id }}</span>
      </el-table-column>
        <el-table-column label="支付状态" prop="status">
         <span slot-scope="{ row }">{{ status2cn(row) }}</span>
      </el-table-column>
      <el-table-column label="申请笔数" prop="total_count">
      </el-table-column>
      <el-table-column label="申请金额（元）" prop="total_amount" min-width="90px"/>
      <el-table-column label="成功笔数" prop="success_count" >
       <span slot-scope="{ row }">{{ row.success_count ===null ? "--":row.success_count }}</span>
      </el-table-column>
      <el-table-column label="成功金额（元）" prop="success_amount" min-width="90px">
          <span slot-scope="{ row }">{{ row.success_amount ===null ? "--":row.success_amount }}</span>
      </el-table-column>
      <el-table-column label="失败笔数" prop="fail_count">
       <span slot-scope="{ row }">{{ row.fail_count ===null ? "--":row.fail_count }}</span>
      </el-table-column>
      <el-table-column label="失败金额（元）" prop="fail_amount" min-width="90px">
       <span slot-scope="{ row }">{{ row.fail_amount ===null ? "--":row.fail_amount }}</span>
      </el-table-column>
      <el-table-column label="操作" min-width="100px" >
        <template slot-scope="{row}">
          <zt-button
            size="mini"
            width="100px"
            @click="download(row.batch_trans_id)"
            type="primary"
            :disabled="row.status !== 1"
          >汇款单下载</zt-button>

          <a v-if="row.status === 0 && row.pay_url" :href="row.pay_url" target="_blank" style="margin-top: 6px; display: block">
            <zt-button
              size="mini"
              width="100px"
              type="primary"
            >去支付</zt-button>
          </a>
        </template>
      </el-table-column>
    </el-table>

      <!-- 分页器 -->
    <div class="pagination mt24">
      <el-pagination
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        :current-page="form.page"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordcount"
        :page-size="form.pagesize"
      />
    </div>
  </pack>
</template>

<script>
import datePickerMixins from '../mixins/datePicker';
import { get_withdraw_batch_list, ereceipt_data_apply } from '@/api/pay.js'
import { status2cn } from '../withdraw/withdraw.utils';
import { dateYMD } from '@/filters/date';
export default {
  name:'FinanceResults',
  mixins: [datePickerMixins],

  data: () => ({
    formLoading: false,
    recordcount:0,
    list: [],
    form:{
      add_time_begin:'',
      add_time_end:'',
      status:'',
      page:1,
      pagesize:10,
    },
    status2cn,

  }),
  mounted() {
    this.getlist()
  },

  computed: {
    date: {
      get() {
        const { add_time_begin, add_time_end } = this.form
        if (add_time_begin && add_time_end) {
          return [ add_time_begin, add_time_end ]
        } else {
          return []
        }
      },
      set(val) {
        if (!val || val.length === 0) {
          this.form.add_time_begin = ''
          this.form.add_time_end = ''
        } else {
          this.form.add_time_begin = dateYMD(val[0]) + ' 00:00:00'
          this.form.add_time_end = dateYMD(val[1]) + ' 23:59:59'
        }

      },
    },
  },
  methods:{
    async getlist( toTop ) {
      this.tableLoading = true;
      const { data } = await get_withdraw_batch_list(this.form)
      console.log(data)
      if (data.error_code != 0) {
        this.$message.error(data.error_message);
      }else {
        this.list=data.list
        this.recordcount=data.recordcount
        if (toTop) {
          window.scrollTo(0, 0);
        }
      }
      this.tableLoading = false
    },
    async download(id) { //下载表格
      const { data } = await ereceipt_data_apply({
        batch_trans_id:id,
      })
      if(!data.error_code) {
        const a = document.createElement('a')
        a.download = true
        if (/^http:\/\//.test(data.download_url)) {
          // a.target = '_blank'
          data.download_url = data.download_url.replace(/^http:/, 'https:')
        }
        a.href = data.download_url
        document.body.append(a)
        a.click()
        a.remove()
      }else {
        this.$message.error(data.error_message);
      }
    },
    //日期改变
    onDatePickerChange() {
      this.onSubmit();
    },
    async onSubmit() {
      this.formLoading = true;
      this.form.page = 1;
      await this.getlist();
      this.formLoading = false
    },
    onReset() {
      this.form = {
        add_time_begin:'',
        add_time_end:'',
        status:'',
        page:1,
        pagesize:10,
      }
      this.getlist()
    },
    onPageSizeChange(size) {
      this.form.pagesize = size;
      // 当前页数*当前页面大小 > 数据总数 的时候不发请求(由onPageChange发请求)
      if (this.form.page * size > this.recordcount && this.form.page != 1)
        return;
      this.getlist()
    },
    onPageChange(page) {
      this.form.page=page
      this.getlist(true);
    },

  },
}
</script>

<style lang="scss" scoped>
.finder {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    display: flex;
  }
}

.el-date-editor {
  width: 340px;
}
.pagination {
  display:flex;
  justify-content: flex-end;
}


.zt-button.is-disabled {
  background: #F3F6FC;
  color: #C2CAD3;
  pointer-events: none;
  border-color: #ccc;
}
</style>
